import React from 'react';
import { createRoot } from 'react-dom/client';
import html2pdf from 'html2pdf.js';
import RoomQuotationTemplate from './RoomQuotationTemplate';

export const generateRoomQuotationPdf = (leadData, customQuotationData) => {
  return new Promise((resolve, reject) => {
    try {
      // Create a temporary container
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.top = '-9999px';
      container.style.left = '-9999px';
      container.style.width = '800px'; // Force width for perfect A4 scaling
      document.body.appendChild(container);

      // Render the React component into the container
      const root = createRoot(container);
      root.render(<RoomQuotationTemplate data={customQuotationData} />);

      // Wait a moment for React to render and images to load
      setTimeout(() => {
        const element = container.firstChild;
        
        const opt = {
          margin: 10,
          filename: `Quotation_${(customQuotationData.clientName || 'Lead').replace(/\s+/g, '_')}_${customQuotationData.quotationNo || 'Draft'}.pdf`,
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { scale: 2, useCORS: true, logging: false, windowWidth: 800, width: 800 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().from(element).set(opt).save().then(() => {
          // Cleanup
          root.unmount();
          document.body.removeChild(container);
          resolve();
        }).catch(err => {
          root.unmount();
          document.body.removeChild(container);
          reject(err);
        });
      }, 500); // 500ms delay to ensure rendering and image loading
    } catch (error) {
      reject(error);
    }
  });
};
